import React from "react";
import { QUESTIONS, evaluate, hsiLevelFor } from "./fagerstromRules";

const LEVEL_CARD = {
    none: "from-emerald-900 to-emerald-700",
    low: "from-emerald-900 to-emerald-700",
    medium: "from-amber-800 to-amber-600",
    high: "from-red-900 to-red-700",
};

const LEVEL_ADVICE = {
    none: "Votre dépendance physique à la nicotine est faible ou absente. L'arrêt repose surtout sur les habitudes et les situations associées à la cigarette.",
    low: "La dépendance physique est faible. Un accompagnement et, si besoin, des substituts nicotiniques facilitent l'arrêt.",
    medium: "La dépendance physique est réelle. Les substituts nicotiniques, à une dose adaptée, augmentent nettement les chances de réussite.",
    high: "La dépendance physique est forte. Faites-vous accompagner : un professionnel adaptera le traitement de substitution, souvent en associant plusieurs formes.",
};

function OptionButton({ selected, onClick, label }) {
    const cls = selected
        ? "bg-slate-800 hover:bg-slate-700 text-white shadow-md"
        : "bg-white hover:bg-stone-50 text-gray-900";
    return (
        <button type="button" onClick={onClick} aria-pressed={selected}
            className={`w-full text-left rounded-lg px-3 py-2 font-semibold text-sm sm:text-base focus:outline-none focus:ring focus:ring-slate-300 ${cls}`}>
            {label}
        </button>
    );
}

export default function Fagerstrom() {
    const [values, setValues] = React.useState({});
    const r = evaluate(values);
    const set = (key, v) => setValues((prev) => ({ ...prev, [key]: v }));

    return (
        <>
            {/* Stays in view while answering the six questions on a phone. */}
            <div className="sticky top-0 z-10 bg-white py-2">
                <div className="flex items-center justify-between bg-stone-100 rounded-lg px-4 py-2">
                    <span className="text-sm sm:text-base text-gray-700">{r.answered} / {QUESTIONS.length} réponses</span>
                    <span className="font-bold text-base sm:text-lg text-gray-900">{r.total ?? "?"}<span className="text-sm font-normal text-gray-600"> / 10</span></span>
                </div>
            </div>

            {QUESTIONS.map((q, i) => (
                <div key={q.key} className="p-3 sm:p-4 my-2 sm:my-3 bg-stone-100 rounded-lg">
                    <p className="font-semibold text-sm sm:text-base text-gray-900 mb-2">{i + 1}. {q.title}</p>
                    <div className={`grid gap-2 ${q.options.length === 2 ? "grid-cols-2" : "grid-cols-1"}`}>
                        {q.options.map((o) => (
                            <OptionButton key={o.label} selected={values[q.key] === o.score} onClick={() => set(q.key, o.score)} label={o.label} />
                        ))}
                    </div>
                </div>
            ))}

            {!r.complete && (
                <div className="p-6 my-2 sm:my-4 bg-stone-50 border border-dashed border-stone-300 rounded-lg text-center">
                    <p className="text-gray-900 font-semibold text-sm sm:text-base">Répondez aux six questions pour obtenir votre score</p>
                    <p className="text-gray-600 text-sm mt-2">Répondez selon vos habitudes actuelles, sans chercher la « bonne » réponse.</p>
                </div>
            )}

            {r.complete && (
                <>
                    <div className={`p-4 my-2 sm:my-4 rounded-lg w-full bg-gradient-to-b ${LEVEL_CARD[r.level.key]} text-white text-center`}>
                        <div className="text-sm opacity-80">Score de Fagerström</div>
                        <div className="text-4xl sm:text-5xl font-bold my-1">{r.total} <span className="text-xl font-semibold">/ 10</span></div>
                        <div className="text-sm font-semibold">{r.level.label}</div>
                    </div>
                    <p className="text-sm text-gray-700">{LEVEL_ADVICE[r.level.key]}</p>
                    <div className="flex items-center justify-between bg-stone-100 rounded-lg px-4 py-2 mt-3">
                        <div>
                            <div className="font-semibold text-sm sm:text-base text-gray-900">Test court (HSI)</div>
                            <div className="text-xs text-gray-600">Questions 1 et 4 · dépendance {hsiLevelFor(r.hsi)}</div>
                        </div>
                        <div className="font-bold text-base sm:text-lg text-gray-900">{r.hsi} <span className="text-sm font-normal text-gray-600">/ 6</span></div>
                    </div>
                    <p className="text-xs text-gray-600 mt-3">Pour être aidé à arrêter : Tabac Info Service, 39 89 (accompagnement gratuit), ou votre médecin, pharmacien, infirmier ou sage-femme.</p>
                </>
            )}

            {Object.keys(values).length > 0 && (
                <div className="text-center mt-2">
                    <button type="button" onClick={() => setValues({})} className="text-sm underline text-gray-700 hover:text-gray-900">Réinitialiser</button>
                </div>
            )}
        </>
    );
}
